"use strict";

exports.__esModule = true;
exports.OrderPdfClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
const OrderPdfClient = {
  /**
   * order pdf urls
   * @return {Promise}
   */
  getOrderPdfUrls({
    orderId,
    orderNumber
  } = {}) {
    const requestId = 'ORDER_PDF_URL';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.ORDER_PDF_URL, {
      orderId,
      orderNumber
    });
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  }
};
exports.OrderPdfClient = OrderPdfClient;